import React from 'react';
import { Moon, Sun } from 'lucide-react';

/**
 * Sun / moon control for the form pages. Same spot on every form (top right,
 * fixed), never a settings page. Pair with useFormTheme():
 *   const { theme, toggle } = useFormTheme();
 *   <FormThemeToggle theme={theme} onToggle={toggle} />
 */
const FormThemeToggle = ({ theme, onToggle, belowNav = false, className = '' }) => {
  const isLight = theme === 'light';
  // Pages that carry the site navbar (z-50) place the control just under it.
  const top = belowNav ? 'top-[76px]' : 'top-3';
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={isLight ? 'Switch to dark view' : 'Switch to light view'}
      title={isLight ? 'Dark view' : 'Light view'}
      data-testid="form-theme-toggle"
      className={`fixed ${top} right-3 z-40 inline-flex items-center gap-1.5 rounded-full border border-border bg-card/90 backdrop-blur px-3 py-1.5 text-xs font-medium text-muted-foreground shadow-sm transition-colors hover:text-foreground hover:bg-muted ${className}`}
    >
      {isLight ? <Moon className="w-3.5 h-3.5" /> : <Sun className="w-3.5 h-3.5" />}
      <span className="hidden sm:inline">{isLight ? 'Dark' : 'Light'}</span>
    </button>
  );
};

export default FormThemeToggle;
